/* eslint-disable react/jsx-handler-names */
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { afterSpin, spin } from "redux/landing/wheels/slice";
import ButtonGirl from "components/atoms/ButtonGirl";
import ButtonTeenagers from "components/atoms/ButtonTeenagers";
import ButtonWheelCards from "components/atoms/ButtonWheelCards";
import ButtonAviator from "components/atoms/ButtonAviator";
import ButtonCrazyTime from "components/atoms/ButtonCrazyTime";
import ButtonChicks from "components/atoms/ButtonChicks";
import { GET_PARAMS, GET_POPUP_TYPES } from "constants/popupConfig";
import * as wheelSelector from "redux/landing/wheels/selectors";
import { WheelType } from "types/Wheel";
import { ButtonRoulette } from "components/atoms/ButtonRoulette";
import { ButtonOlympus } from "components/atoms/ButtonOlympus";
import { useGTM } from "../../hooks/useGTM";
import { ButtonBonanza } from "../../components/atoms/ButtonBonanza";

const ButtonContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation().pathname;
  const GTM = useGTM();
  const { attempts, disabled, type } = useSelector(wheelSelector.all);

  const onClick = () => {
    dispatch(spin());
    const name = location.split("/wheels")[1].replace("/", "");
    if (attempts && attempts === 2) {
      GTM.clickSpinWheel(name);
    } else {
      GTM.clickSpinAgainWheel(name);
    }

    setTimeout(() => {
      dispatch(afterSpin());
      navigate({
        search: `?${createSearchParams({
          [GET_PARAMS.POPUP]:
            attempts === 2
              ? GET_POPUP_TYPES.popup.winWheel
              : GET_POPUP_TYPES.popup.regWheel,
        })}`,
      });
    }, 4000);
  };

  return (
    <>
      {(type === WheelType.GIRLS || type === WheelType.GIRLS_BANGLADESH) && (
        <ButtonGirl attempts={attempts} disabled={disabled} onClick={onClick} />
      )}
      {type === WheelType.TEENAGERS && (
        <ButtonTeenagers
          attempts={attempts}
          disabled={disabled}
          onClick={onClick}
        />
      )}
      {type === WheelType.CARDS && (
        <ButtonWheelCards
          attempts={attempts}
          disabled={disabled}
          onClick={onClick}
        />
      )}
      {type === WheelType.AVIATOR && (
        <ButtonAviator
          attempts={attempts}
          disabled={disabled}
          onClick={onClick}
        />
      )}
      {type === WheelType.CRAZY_TIME && (
        <ButtonCrazyTime
          attempts={attempts}
          disabled={disabled}
          onClick={onClick}
        />
      )}
      {(type === WheelType.CHICKS_TURKEY ||
        type === WheelType.CHICKS_BANGLADESH ||
        type === WheelType.CHICKS_AZER ||
        type === WheelType.CHICKS_UZBEKISTAN) && (
        <ButtonChicks
          attempts={attempts}
          disabled={disabled}
          onClick={onClick}
        />
      )}
      {type === WheelType.ROULETTE && (
        <ButtonRoulette
          attempts={attempts}
          disabled={disabled}
          onClick={onClick}
        />
      )}
      {type === WheelType.SWEET_BONANZA && (
        <ButtonBonanza
          attempts={attempts}
          disabled={disabled}
          onClick={onClick}
        />
      )}
      {type === WheelType.GATES_OLYMPUS && (
        <ButtonOlympus
          attempts={attempts}
          disabled={disabled}
          onClick={onClick}
        />
      )}
    </>
  );
};

export default ButtonContainer;
